<template>
  <v-snackbar
    v-model="visivel"
    :color="cor"
    :timeout="6000"
    :top="isTop"
    :bottom="isBottom"
    :left="isLeft"
    :right="isRight"
    rounded="pill"
  >
    <v-icon left>{{ icone }}</v-icon>
    {{ mensagem }}

    <template v-slot:action="{ attrs }">
      <v-btn icon v-bind="attrs" @click="visivel = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "GlobalSnackbar",
  data() {
    return {
      visivel: false,
      mensagem: "",
      tipo: "info", // success, error, warning, info
      posicao: "top", // posição padrão
    };
  },
  computed: {
    cor() {
      return {
        success: "green",
        error: "red",
        warning: "orange",
        info: "blue",
      }[this.tipo];
    },
    icone() {
      return {
        success: "mdi-check-circle",
        error: "mdi-alert-circle",
        warning: "mdi-alert",
        info: "mdi-information",
      }[this.tipo];
    },
    isTop() {
      return this.posicao.includes("top");
    },
    isBottom() {
      return this.posicao.includes("bottom");
    },
    isLeft() {
      return this.posicao.includes("left");
    },
    isRight() {
      return this.posicao.includes("right");
    },
  },
  methods: {
    /**
     * Exibe a snackbar
     * @param {String} mensagem - Texto a ser exibido
     * @param {String} tipo - success | error | warning | info
     * @param {String} posicao - top, bottom, top-right, etc.
     */
    mostrar(mensagem, tipo = "info", posicao = "top") {
      this.mensagem = mensagem;
      this.tipo = tipo;
      this.posicao = posicao;
      this.visivel = true;
    },
  },
};
</script>
